const TIMESTAMP_PARAM = "sharingTimestampSec";

function isResponseJson(resp) {
  const contentType = resp.headers.get("content-type");
  return contentType.includes("application/json");
}

/**
 * Check if response is success and has JSON format and then return parsed object
 * @param {*} resp Fetch response object
 * @returns {Promise} Promise that return JSON object
 */
export const parseJsonResponse = async resp => {
  if (!isResponseJson(resp)) {
    if (!resp.ok) {
      throw new Error(`HTTP Error ${resp.status}: ${resp.statusText}`);
    } else {
      throw new Error("No JSON response");
    }
  }

  const jsonResp = await resp.json();
  return jsonResp;
};

/**
 * Make standard request with JSON encoded data and return JSON parsed response
 * @param {Object} param0 url, method and data to fetch request
 */
export async function makeJsonRequest({ url, method, data }) {
  const resp = await fetch(url, {
    method: method,
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    }
  });

  const respObj = await resp.json();
  if (!respObj.success) {
    throw Error(respObj.error);
  }

  return respObj;
}

/**
 * @param {String} url URL to be timestamped
 * @param {Date} datetime timestamp
 * @returns {String} new URL with timestamp query parameter
 */
export const getTimestampedUrl = (url, datetime) => {
  if (!datetime) return url;

  const urlObject = new URL(url);
  urlObject.searchParams.set(TIMESTAMP_PARAM, Math.round(datetime / 1000));
  return urlObject.toString();
};
